import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=17a6e90c&scoped=true"
import script from "./Sports.vue?vue&type=script&lang=js"
export * from "./Sports.vue?vue&type=script&lang=js"
import style0 from "./Sports.vue?vue&type=style&index=0&id=17a6e90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a6e90c",
  null
  
)

export default component.exports